import { useActivityFeedStore } from "client/Features/ActivityFeed/store";
import {
	MainMenuItem,
	useMainMenuItemActivationHandlers
} from "client/Features/Layout/mainMenuStore";
import {
	ReactElement,
	RefObject,
	useRef,
	useState
} from "react";
import { MenuItem } from "../MenuItem/MenuItem";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { ensureNotNil } from "client/Misc/utils";
import { ActivityMenu } from "./ActivityMenu";
import { NotificationSettingsDialog } from "client/Features/ActivityFeed/Settings/NotificationSettingsDialog";

export type ActivityMenuItemProps = {
	headerStyle: WorkspaceHeaderStyle;
};

export const ActivityMenuItem = (props: ActivityMenuItemProps): ReactElement => {
	const {
		headerStyle
	} = props;

	const [isNotificationSettingsDialogOpen, setIsNotificationSettingsDialogOpen] = useState<boolean>(false);

	const {
		isActive,
		toggle,
		deactivate
	} = useMainMenuItemActivationHandlers(MainMenuItem.Activity);

	const itemRef: RefObject<HTMLLIElement | null> = useRef<HTMLLIElement>(null);

	const unreadCount: number | undefined = useActivityFeedStore(state => state.amountOfUnreadNotifications);

	return (
		<>
			<MenuItem
				ref={itemRef}
				icon="bell"
				count={unreadCount}
				isActive={isActive}
				onClick={toggle}
				trackingId="activity"
				headerStyle={headerStyle}
			/>

			{isActive && (
				<ActivityMenu
					onClose={deactivate}
					targetElement={ensureNotNil(itemRef.current)}
					onOpenSettings={() => setIsNotificationSettingsDialogOpen(true)}
					isSettingsOpen={isNotificationSettingsDialogOpen}
				/>
			)}

			{isNotificationSettingsDialogOpen && (
				<NotificationSettingsDialog
					onClose={() => setIsNotificationSettingsDialogOpen(false)}
				/>
			)}
		</>
	);
};

ActivityMenuItem.displayName = "ActivityMenuItem";